module.exports = __webpack_public_path__ + "assets/img/30.56500c59.jpg";